import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'swapout/voucher', data),
  get: (id) => Ajax('get', `swapout/voucher/${id}`),
  create: (data) => Ajax('post', 'swapout/voucher/create', data),
  import: (data) => Ajax('post', 'swapout/voucher/import', data),
  summary: (id) => Ajax('get', `swapout/voucher/statusSummary/${id}`),
  changeStatus: (vid, status) => Ajax('put', `swapout/voucher/${vid}?status=${status}`),
  getVoucherLog: (vid) => Ajax('get', `swapout/voucher/${vid}/logs`),
};
